module.exports = __webpack_public_path__ + "img/AD.a464d4a5.svg";